import { Box } from "@mui/material";

interface Props {
  onClick?: () => void;
  style?: any;
}
export const ISortNorth: React.FC<Props> = (props) => {
  return (
    <Box display="flex" {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="17"
        viewBox="0 -960 960 960"
        width="17"
        fill="currentColor"
        style={{ fontWeight: "bold" }}
      >
        <path d="M440-160v-487L216-423l-56-57 320-320 320 320-56 57-224-224v487h-80Z" strokeWidth="20" stroke="currentColor"/>
      </svg>
    </Box>
  );
};
